import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';
import {entities, tagTypes} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';
import {useEngagementId} from '../../../util/customHooks';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import CreateEditTagModal from '../CanvasForm/Bodies/BodyTypes/SampleList/CreateEditTagModal/src';
import {createTag, updateSampleItemTag} from '../../../actions/SampleItems/sampleItemActions';
import {clearErrors} from '../../../actions/erroractions';

export default function CreateEditSampleTagModalWrapper(props) {
	const {
		isCreate,
		showModal,
		setShowModal,
		onClose,
		tagGroups,
		entityId,
		sampleItemId,
		paginationParamsForServerCall,
		getAllAction
	} = props;
	const engagementId = useEngagementId();
	const dispatch = useDispatch();
	const tagItem = useSelector((state) => state.tagItems?.tags?.byId[entityId]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		dispatch(clearErrors());
		return () => {
			dispatch(clearErrors());
		};
	}, [showModal]);

	return (
		<>
			{isCreate && (
				<CreateEditTagModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditTagLabels}
					tagGroups={tagGroups}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
					createTagAction={(data) =>
						dispatch(createTag(engagementId, data)).then(() => {
							dispatch(
								getAllAction({
									...paginationParamsForServerCall,
									includePagination: true
								})
							);
						})
					}
					onClose={onClose}
					errorComponent={<ErrorSummary />}
					theme={Utility.getTheme()}
					entityId={entities.SampleItem}
					tagTypeId={tagTypes.FilteringNotArchived}
				/>
			)}
			{!isCreate && (
				<CreateEditTagModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditTagLabels}
					tagGroups={tagGroups}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
					editTagAction={(data) =>
						dispatch(updateSampleItemTag(engagementId, tagItem?.id, {...data, sampleItemId: sampleItemId})).then(() => {
							dispatch(
								getAllAction({
									...paginationParamsForServerCall,
									includePagination: true
								})
							);
						})
					}
					onClose={onClose}
					errorComponent={<ErrorSummary />}
					theme={Utility.getTheme()}
					entityId={entities.SampleItem}
					tagTypeId={tagTypes.FilteringNotArchived}
					isEditModal={true}
					tagItem={tagItem}
				/>
			)}
		</>
	);
}
